<template>
  <v-tooltip color="black" top :disabled="disableTooltip">
    <template v-slot:activator="{ on }">
      <keep-alive>
        <component
          :is="computedTag"
          v-html="text"
          :class="[...classProp]"
          :style="[
            additionalStyling ? additionalStyling : '',
            applyClamp ? clampText : ''
          ]"
          v-on="on"
          :id="id && id !== '' ? id : ''"
        ></component>
      </keep-alive>
    </template>

    <span v-html="text"></span>
  </v-tooltip>
</template>
<script>
export default {
  props: {
    tag: {
      type: String,
      required: false,
      default: 'p'
    },

    text: {
      type: String,
      required: true
    },

    disableTooltip: {
      type: Boolean,
      required: false,
      default: true
    },

    classProp: {
      type: Array,
      required: false
    },

    lineClamp: {
      type: Number,
      required: true
    },

    truncateWidth: {
      type: String,
      default: '100%'
    },

    minHeight: {
      type: String,
      required: false
    },

    additionalStyling: {
      type: Object,
      required: false
    },

    id: {
      type: String,
      required: false
    },

    applyClamp: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data() {
    return {
      clampText: {
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden'
      }
    };
  },

  created() {
    this.clampText['-webkit-line-clamp'] = this.lineClamp;
    this.clampText['max-width'] = this.truncateWidth;

    if (this.minHeight) this.clampText['min-height'] = this.minHeight;
  },

  computed: {
    computedTag() {
      return this.tag;
    }
  }
};
</script>

<style scoped></style>
